import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { deleteProductStatus } from '../constants/delete-products-status.constant';
import '../style.css';

export const checkStatus = (status) => {
	if (deleteProductStatus[Enviroment.LANGUAGE][status]) {
		return false
	}
	return true
};
